export default {
    monitor: {name: "Monitor"},
    keyboard: {name: "Toetsenbord"},
    mouse: {name: "Muis"},
    webcam: {name: "Webcam"},
    headset: {name: "Hoofdtelefoon"},
    dockingStation: {name: "Docking station"},
}